import { controls } from "../../controls";

const ms242 = {
  label: "Release Lein Marking Of Loan",
  pageLabel: "Release Lein Marking Of Loan",
  starting: true,
  url: "ms242",
  pageType: "history",
  form: [],
  filter: [
    ...controls.displayText({ tab: "filter", star: true, label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", isRequired: true, defaultValue: "assigned_branch", width: "col-sm-2" }),

    ...controls.showData({ tab: "filter", data: "branch_display", isRequired: true, name: "branch_display", }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.displayText({ tab: "filter", label: "Loan Product", width: "col-sm-2" }),
    ...controls.product({ tab: "filter", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", width: "col-sm-2", data: "product_code_display", name: "product_code_display" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.displayText({ tab: "filter", label: "Loan Account Code", width: "col-sm-2" }),
    ...controls.AccountNumber({
      tab: "filter", beforeLeave: ["createAcNo"],
    }),
    ...controls.showData({ data: "account_number_display", width: "col-sm-2" }),
    ...controls.magicDateLabel({ tab: "filter", label: "Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "date", width: "col-sm-2", default: "sessiondate" }),

  ],
  history: {
    perPage: 10,
    displayColumns: [
      {
        Header: "Release",
        accessor: "release_checked"
      },
      {
        Header: "Account Number",
        accessor: "account_no"
      },
      {
        Header: "Name",
        accessor: "dname"
      },
      {
        Header: "FD AMount",
        accessor: "fd_amount",
        type: "currency"
      },
      {
        Header: "Opening Date",
        accessor: "open_date"
      },
      {
        Header: "Expiry Date",
        accessor: "expdate"
      },
      {
        Header: "Make Date",
        accessor: "mark_date"
      },
      {
        Header: "Mark Amount",
        accessor: "mark_fd_amount",
        type: "currency"
      },
      {
        Header: "Mark By",
        accessor: "mark_by"
      },
      {
        Header: "Release Date",
        accessor: "release_date"
      },
      {
        Header: "Release by",
        accessor: "release_by"
      }
    ]
  }
};

export default ms242;
